module.exports = __webpack_public_path__ + "static/img/MYbank@2x.5e8da56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/MYBANK_pc/MYbank@2x.png
// module id = 8Un6
// module chunks = 70